import { createReducer } from '@reduxjs/toolkit'

import { IPWAState } from '../types'
import * as actions from '../actions'

const initialState: IPWAState = {
  isNotificationShown: false,
}

export default createReducer(initialState, builder => {
  builder.addCase(actions.hideNotification, state => {
    state.isNotificationShown = true
  })
})
